interface SkeletonProps {
  className?: string
  variant?: 'text' | 'text-short' | 'avatar' | 'image'
}

export function Skeleton({ className, variant }: SkeletonProps) {
  const variantClass = variant ? ` wefa-skeleton--${variant}` : ''
  return (
    <div
      aria-hidden="true"
      className={`wefa-skeleton${variantClass}${className ? ` ${className}` : ''}`}
      role="presentation"
    />
  )
}
